export default __webpack_public_path__ + "static/media/imageTwo.4cfc5cd2.svg";